import axios from 'axios';

export const serverUrl = process.env.REACT_APP_API_URL ?? 'http://localhost:5000';
const apiVersion = 'V1';
const apiUrl = `${serverUrl}/api/${apiVersion}/`;

export const useAxios = (withCredentials: boolean = false) => {
    const axiosInstance = axios.create({
        baseURL: apiUrl,
        withCredentials: withCredentials,
        maxRedirects: 0,
        headers: {
            'Content-Type': 'application/json'
        }
    });

    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            //console.error(`Error: ${error.response?.status} ${error.config.method?.toUpperCase()} ${error.config.url}`);
            if (error.response?.status >= 400 && window.location.pathname !== '/login') {
                //redirect to login page
                window.location.href = '/login';
                return;
            }
        }
    );

    return axiosInstance;
};
